import {actions} from "xstate";
const {raise, choose} = actions;

const makeMachine = () => ({
    id: "arcman",
    type: "parallel",
    context: {
        arcologyConstants: {},
        applications: [],
        applicationsSortField: {},
        forceLoadApplicationsFlag: true,
        forceLoadDevicesFlag: true,
        forceLoadProjectsFlag: true,
        forceLoadWarehousesFlag: true,
        filters: null,
        filtersCriteria: null,
        searchCriteria: "",
        filteredApplications: [],
        statisticsApplications: [],
        devices: {},
        openApplicationsSelectedProjectId: "",
        projects: [],
        projectCompatibleApplications: [],
        filteredProjectCompatibleApplications: [],
        isAuthenticated: false,
        modalIsShown: false,
        modalMessage: "",
        modalType: "",
        uploadedFilesUrls: {},
        warehouses: [],
        warehouseExportedApplications: [],
    },
    states: {
        load: {
            id: "load",
            type: "parallel",
            states: {
                constants: {
                    initial: "idle",
                    states: {
                        fallback: {
                            entry: ["showError"],
                            on: {
                                RESET_ERROR: {target: "idle"},
                            },
                        },
                        idle: {
                            on: {
                                LOAD_ARCOLOGY_CONSTANTS: "processing",
                            },
                        },
                        processing: {
                            invoke: {
                                src: "loadArcologyConstants",
                                onDone: {
                                    actions: [(context, event) => (context.arcologyConstants = event.data)],
                                    target: "idle",
                                },
                                onError: "fallback",
                            },
                        },
                    },
                },
                filters: {
                    initial: "idle",
                    states: {
                        fallback: {
                            entry: ["showError"],
                            on: {
                                RESET_ERROR: {target: "idle"},
                            },
                        },
                        idle: {
                            on: {
                                RELOAD_FILTERS: {target: "reloadFilters", cond: (context, event) => context.filters},
                                UPDATE_FILTERS: "updateFilters",
                            },
                        },
                        reloadFilters: {
                            invoke: {
                                src: "reloadFilters",
                                onDone: {
                                    actions: choose([
                                        {actions: "setFiltersOptions", cond: (context, event) => context.filters},
                                    ]),
                                    target: "idle",
                                },
                                onError: "fallback",
                            },
                        },
                        updateFilters: {
                            invoke: {
                                src: "updateFilters",
                                onDone: {
                                    actions: choose([
                                        {actions: "setFiltersOptions", cond: (context, event) => context.filters},
                                    ]),
                                    target: "idle",
                                },
                                onError: "fallback",
                            },
                        },
                    },
                },
                applications: {
                    initial: "idle",
                    states: {
                        fallback: {
                            entry: ["showError"],
                            on: {
                                RESET_ERROR: {target: "idle"},
                            },
                        },
                        idle: {
                            on: {
                                LOAD_APPLICATIONS: {target: "processing"},
                                BACKGROUND_LOAD_APPLICATIONS: {target: "backgroundLoadApplications"},
                            },
                        },
                        processing: {
                            invoke: {
                                src: "loadApplications",
                                onDone: {
                                    actions: [
                                        "setInventoryApplications",
                                        "setFilteredInventoryApplications",
                                        "sortInventoryApplications",
                                        "filterAndSearchInventoryApplications",
                                    ],
                                    target: "idle",
                                },
                                onError: "fallback",
                            },
                        },
                        backgroundLoadApplications: {
                            invoke: {
                                src: "loadApplications",
                                onDone: {
                                    actions: ["setInventoryApplications"],
                                    target: "idle",
                                },
                                onError: "fallback",
                            },
                        },
                    },
                },
                statistics: {
                    initial: "idle",
                    states: {
                        fallback: {
                            entry: ["showError"],
                            on: {
                                RESET_ERROR: {target: "idle"},
                            },
                        },
                        idle: {
                            on: {
                                LOAD_STATISTICS: "processing",
                            },
                        },
                        processing: {
                            invoke: {
                                src: "loadStatisticsData",
                                onDone: {
                                    target: "idle",
                                    actions: ["setStatisticsApplications"],
                                },
                                onError: "fallback",
                            },
                        },
                    },
                },
                devices: {
                    initial: "idle",
                    states: {
                        fallback: {
                            entry: ["showError"],
                            on: {
                                RESET_ERROR: {target: "idle"},
                            },
                        },
                        idle: {
                            on: {
                                LOAD_DEVICES: {target: "processing"},
                            },
                        },
                        processing: {
                            invoke: {
                                src: "loadDevices",
                                onDone: {
                                    actions: [
                                        (context, event) => {
                                            context.devices = event.data;
                                        },
                                    ],
                                    target: "idle",
                                },
                                onError: "fallback",
                            },
                        },
                    },
                },
                projects: {
                    initial: "idle",
                    states: {
                        fallback: {
                            entry: ["showError"],
                            on: {
                                RESET_ERROR: {target: "idle"},
                            },
                        },
                        idle: {
                            on: {
                                LOAD_PROJECTS: "processing",
                            },
                        },
                        processing: {
                            invoke: {
                                src: "loadProjects",
                                onDone: {
                                    actions: [
                                        "setProjects",
                                        "selectProject",
                                        "filterAndSearchProjectApplications",
                                        "countFilteredProjectCompatibleApplicationsInSelectedProjectCategories",
                                        "sortFilteredProjectCompatibleApplications",
                                    ],
                                    target: "idle",
                                },
                                onError: "fallback",
                            },
                        },
                    },
                },
                selectedProject: {
                    initial: "idle",
                    states: {
                        fallback: {
                            entry: ["showError"],
                            on: {
                                RESET_ERROR: {target: "idle"},
                            },
                        },
                        idle: {
                            on: {
                                RELOAD_SELECTED_PROJECT: "processing",
                            },
                        },
                        processing: {
                            invoke: {
                                src: "loadSelectedProject",
                                onDone: {
                                    actions: [
                                        "updateProject",
                                        "selectProject",
                                        "filterAndSearchProjectApplications",
                                        "countFilteredProjectCompatibleApplicationsInSelectedProjectCategories",
                                        "sortFilteredProjectCompatibleApplications",
                                    ],
                                    target: "idle",
                                },
                                onError: "fallback",
                            },
                        },
                    },
                },
                upload: {
                    initial: "idle",
                    states: {
                        fallback: {
                            entry: ["showError"],
                            on: {
                                RESET_ERROR: {target: "idle"},
                            },
                        },
                        idle: {
                            on: {
                                UPLOAD: {target: "processing"},
                            },
                        },
                        processing: {
                            invoke: {
                                src: "upload",
                                onDone: {
                                    actions: ["appendUploadedFileUrl"],
                                    target: "idle",
                                },
                                onError: "fallback",
                            },
                        },
                    },
                },
                warehouses: {
                    initial: "idle",
                    states: {
                        fallback: {
                            entry: ["showError"],
                            on: {
                                RESET_ERROR: {target: "idle"},
                            },
                        },
                        idle: {
                            on: {
                                LOAD_WAREHOUSES: {target: "processing"},
                            },
                        },
                        processing: {
                            invoke: {
                                src: "loadWarehouses",
                                onDone: {
                                    actions: [
                                        (context, event) => {
                                            context.warehouses = event.data;
                                            context.forceLoadWarehousesFlag = false;
                                        },
                                    ],
                                    target: "idle",
                                },
                                onError: "fallback",
                            },
                        },
                    },
                },
            },
        },
        pages: {
            initial: "default",
            on: {
                GOTO_applications: ".applications",
                GOTO_statistics: ".statistics",
                GOTO_devices: ".devices",
                GOTO_managedDevices: ".managedDevices",
                GOTO_projects: ".projects",
                GOTO_warehouses: ".warehouses",
                RESET_FILTERS: {actions: ["resetFilters"]},
                SET_LANGUAGE: {
                    actions: choose([
                        {
                            cond: (context, event) => context.filters && context.filtersCriteria,
                            actions: [
                                "setLanguage",
                                "resetFilters",
                                raise("APPLY_FILTERS"),
                                raise("RELOAD_FILTERS"),
                                raise("SORT_APPLICATIONS"),
                            ],
                        },
                        {
                            actions: ["setLanguage", raise("SORT_APPLICATIONS")],
                        },
                    ]),
                },
                SET_SEARCH_CRITERIA: {actions: ["setSearchCriteria"]},
                SHOW_MODAL: {
                    actions: [
                        (context, event) => {
                            context.modalIsShown = true;
                            context.modalMessage = event[0];
                            context.modalType = event[1];
                        },
                    ],
                },
                HIDE_MODAL: {actions: [(context, event) => (context.modalIsShown = false)]},
            },
            states: {
                default: {},
                applications: {
                    id: "applications",
                    initial: "idle",
                    states: {
                        fallback: {
                            entry: ["showError"],
                            on: {
                                RESET_ERROR: {target: "idle.ready"},
                            },
                        },
                        idle: {
                            initial: "init",
                            states: {
                                init: {
                                    entry: choose([
                                        {
                                            cond: "forceLoadApplications",
                                            actions: [
                                                raise("LOAD_APPLICATIONS"),
                                                raise("LOAD_WAREHOUSES"),
                                                "unflagForceLoadApplications",
                                                "unflagForceLoadWarehouses",
                                            ],
                                        },
                                        {
                                            actions: ["setFilteredInventoryApplications"],
                                        },
                                    ]),
                                },
                                ready: {
                                    entry: [raise("RELOAD_FILTERS")],
                                },
                            },
                            on: {
                                APPLY_FILTERS: {
                                    actions: ["filterAndSearchInventoryApplications"],
                                },
                                SET_CRITERIA_THEN_APPLY_FILTERS: {
                                    actions: ["setFiltersCriteria", "filterAndSearchInventoryApplications"],
                                },
                                INIT_FILTERS: {actions: "initFilters"},
                                SET_CRITERIA_THEN_SEARCH_APPLICATIONS: {
                                    actions: ["setSearchCriteria", "filterAndSearchInventoryApplications"],
                                },
                                SET_APPLICATIONS_SORT_FIELD: {actions: "setApplicationsSortField"},
                                SORT_APPLICATIONS: {actions: "sortInventoryFilteredApplications"},
                                CREATE_APPLICATION: "processing.creatingApp",
                                IMPORT_APPLICATIONS: "processing.importApplications",
                                DELETE_APPLICATION: "processing.deleting",
                                SAVE_APPLICATION: "processing.saving",
                                DELETE_VERSION: "processing.deletingVersion",
                            },
                        },
                        processing: {
                            states: {
                                saving: {
                                    invoke: {
                                        src: "saveApplication",
                                        onDone: {
                                            actions: [
                                                "updateFilteredApplication",
                                                raise("BACKGROUND_LOAD_APPLICATIONS"),
                                            ],
                                            target: "#applications.idle.ready",
                                        },
                                        onError: "#applications.fallback",
                                    },
                                },
                                deleting: {
                                    invoke: {
                                        src: "deleteApplication",
                                        onDone: {
                                            actions: [
                                                "deleteFilteredApplication",
                                                raise("BACKGROUND_LOAD_APPLICATIONS"),
                                            ],
                                            target: "#applications.idle.ready",
                                        },
                                        onError: "#applications.fallback",
                                    },
                                },
                                creatingApp: {
                                    invoke: {
                                        src: "createApplication",
                                        onDone: {
                                            actions: [raise("LOAD_APPLICATIONS")],
                                            target: "#applications.idle.ready",
                                        },
                                        onError: "#applications.fallback",
                                    },
                                },
                                importApplications: {
                                    invoke: {
                                        src: "importApplications",
                                        onDone: "#applications",
                                        onError: "#applications.fallback",
                                    },
                                },
                                deletingVersion: {
                                    invoke: {
                                        src: "deleteVersion",
                                        onDone: "#applications.idle.ready",
                                        onError: "#applications.fallback",
                                    },
                                },
                            },
                        },
                    },
                },
                projects: {
                    id: "projects",
                    initial: "idle",
                    states: {
                        fallback: {
                            entry: ["showError"],
                            on: {
                                RESET_ERROR: {target: "idle.ready"},
                            },
                        },
                        idle: {
                            initial: "init",
                            states: {
                                init: {
                                    entry: [
                                        choose([
                                            {
                                                cond: "forceLoadApplications",
                                                actions: [
                                                    raise("LOAD_APPLICATIONS"),
                                                    raise("LOAD_PROJECTS"),
                                                    "unflagForceLoadApplications",
                                                ],
                                            },
                                            {
                                                cond: "forceLoadProjects",
                                                actions: [raise("LOAD_PROJECTS")],
                                            },
                                        ]),
                                    ],
                                },
                                ready: {
                                    entry: [raise("RELOAD_SELECTED_PROJECT")],
                                },
                            },
                            on: {
                                SELECT_PROJECT: {
                                    actions: [
                                        "selectProject",
                                        "filterAndSearchProjectApplications",
                                        "countFilteredProjectCompatibleApplicationsInSelectedProjectCategories",
                                        "sortFilteredProjectCompatibleApplications",
                                    ],
                                },
                                APPLY_FILTERS: {
                                    actions: [
                                        "filterAndSearchProjectApplications",
                                        "countFilteredProjectCompatibleApplicationsInSelectedProjectCategories",
                                        "sortFilteredProjectCompatibleApplications",
                                    ],
                                },
                                SET_CRITERIA_THEN_APPLY_FILTERS: {
                                    actions: [
                                        "setFiltersCriteria",
                                        "filterAndSearchProjectApplications",
                                        "countFilteredProjectCompatibleApplicationsInSelectedProjectCategories",
                                        "sortFilteredProjectCompatibleApplications",
                                    ],
                                },
                                INIT_FILTERS: {actions: ["initProjectApplicationsFilters"]},
                                SET_CRITERIA_THEN_SEARCH_APPLICATIONS: {
                                    actions: [
                                        "setSearchCriteria",
                                        "filterAndSearchProjectApplications",
                                        "countFilteredProjectCompatibleApplicationsInSelectedProjectCategories",
                                        "sortFilteredProjectCompatibleApplications",
                                    ],
                                },
                                SET_APPLICATIONS_SORT_FIELD: {actions: "setApplicationsSortField"},
                                SORT_APPLICATIONS: {actions: "sortFilteredProjectCompatibleApplications"},
                                CREATE_PROJECT: "processing.creatingProject",
                                UPDATE_PROJECT: "processing.updatingProject",
                                DELETE_PROJECT: "processing.deletingProject",
                                CREATE_CATEGORY: "processing.creatingCategory",
                                DELETE_CATEGORY: "processing.deletingCategory",
                                SWAP_PROJECT_CATEGORIES: "processing.swapingProjectCategories",
                                SWAP_CATEGORY_VERSIONS: "processing.swapingCategoryVersions",
                            },
                        },
                        processing: {
                            states: {
                                creatingProject: {
                                    invoke: {
                                        src: "createProject",
                                        onDone: {target: "#projects"},
                                        onError: "#projects.fallback",
                                    },
                                },
                                updatingProject: {
                                    invoke: {
                                        src: "updateProject",
                                        onDone: {target: "#projects"},
                                        onError: "#projects.fallback",
                                    },
                                },
                                deletingProject: {
                                    invoke: {
                                        src: "deleteProject",
                                        onDone: {target: "#projects"},
                                        onError: "#projects.fallback",
                                    },
                                },
                                creatingCategory: {
                                    invoke: {
                                        src: "createCategory",
                                        onDone: {
                                            target: "#projects.idle.ready",
                                        },
                                        onError: "#projects.fallback",
                                    },
                                },
                                deletingCategory: {
                                    invoke: {
                                        src: "deleteCategory",
                                        onDone: {
                                            target: "#projects.idle.ready",
                                        },
                                        onError: "#projects.fallback",
                                    },
                                },
                                swapingProjectCategories: {
                                    invoke: {
                                        src: "swapProjectCategories",
                                        onDone: "#projects.idle.ready",
                                        onError: "#projects.fallback",
                                    },
                                },
                                swapingCategoryVersions: {
                                    invoke: {
                                        src: "swapCategoryVersions",
                                        onDone: "#projects.idle.ready",
                                        onError: "#projects.fallback",
                                    },
                                },
                            },
                        },
                    },
                },
                statistics: {
                    id: "statistics",
                    initial: "idle",
                    states: {
                        fallback: {
                            entry: ["showError"],
                            on: {
                                RESET_ERROR: {target: "idle"},
                            },
                        },
                        idle: {
                            entry: choose([
                                {
                                    cond: "forceLoadApplications",
                                    actions: [
                                        raise("LOAD_APPLICATIONS"),
                                        raise("LOAD_PROJECTS"),
                                        "unflagForceLoadApplications",
                                    ],
                                },
                                {
                                    actions: [raise("LOAD_PROJECTS")],
                                },
                            ]),
                        },
                    },
                    on: {
                        SELECT_PROJECT: {
                            actions: ["selectProject"],
                        },
                    },
                },
                devices: {
                    id: "devices",
                    initial: "idle",
                    states: {
                        fallback: {
                            entry: ["showError"],
                            on: {
                                RESET_ERROR: {target: "idle"},
                            },
                        },
                        idle: {
                            entry: choose([
                                {
                                    cond: "forceLoadDevices",
                                    actions: [
                                        raise("LOAD_DEVICES"),
                                        "unflagForceLoadDevices",
                                        raise("LOAD_APPLICATIONS"),
                                        "unflagForceLoadApplications",
                                    ],
                                },
                                {
                                    cond: "forceLoadApplications",
                                    actions: [raise("LOAD_APPLICATIONS"), "unflagForceLoadApplications"],
                                },
                            ]),
                            on: {
                                DEVICES_STORE: "processing.store",
                                DEVICE_UPDATE: "processing.update",
                                DEVICE_DESTROY: "processing.destroy",
                            },
                        },
                        processing: {
                            states: {
                                store: {
                                    exit: [raise("LOAD_DEVICES")],
                                    invoke: {
                                        src: "createDevice",
                                        onDone: "#devices",
                                        onError: "#devices.fallback",
                                    },
                                },
                                update: {
                                    exit: [raise("LOAD_DEVICES")],
                                    invoke: {
                                        src: "saveDevice",
                                        onDone: "#devices",
                                        onError: "#devices.fallback",
                                    },
                                },
                                destroy: {
                                    exit: [raise("LOAD_DEVICES")],
                                    invoke: {
                                        src: "deleteDevice",
                                        onDone: "#devices",
                                        onError: "#devices.fallback",
                                    },
                                },
                            },
                        },
                    },
                },
                managedDevices: {
                    id: "managedDevices",
                    initial: "idle",
                    states: {
                        idle: {},
                    },
                },
                warehouses: {
                    id: "warehouses",
                    initial: "idle",
                    states: {
                        fallback: {
                            entry: ["showError"],
                            on: {
                                RESET_ERROR: {target: "idle"},
                            },
                        },
                        idle: {
                            initial: "main",
                            on: {
                                WAREHOUSES_STORE: "processing.store",
                                WAREHOUSE_UPDATE: "processing.update",
                                WAREHOUSE_DESTROY: "processing.destroy",
                                WAREHOUSE_EXPORT_APPLICATIONS: "processing.exportApplications",
                                WAREHOUSE_IMPORT_APPLICATIONS: "processing.importApplications",
                            },
                            states: {
                                main: {
                                    always: [{target: "load", cond: "forceLoadWarehouses"}],
                                },
                                load: {entry: [raise("LOAD_WAREHOUSES"), "unflagForceLoadWarehouses"]},
                            },
                        },
                        processing: {
                            states: {
                                store: {
                                    exit: [raise("LOAD_WAREHOUSES")],
                                    invoke: {
                                        src: "warehousesStore",
                                        onDone: "#warehouses",
                                        onError: "#warehouses.fallback",
                                    },
                                },
                                update: {
                                    exit: [raise("LOAD_WAREHOUSES")],
                                    invoke: {
                                        src: "warehouseUpdate",
                                        onDone: "#warehouses",
                                        onError: "#warehouses.fallback",
                                    },
                                },
                                destroy: {
                                    exit: [raise("LOAD_WAREHOUSES")],
                                    invoke: {
                                        src: "warehouseDestroy",
                                        onDone: "#warehouses",
                                        onError: "#warehouses.fallback",
                                    },
                                },
                                importApplications: {
                                    exit: [raise("LOAD_APPLICATIONS")],
                                    invoke: {
                                        src: "warehouseImportApplications",
                                        onDone: "#warehouses",
                                        onError: "#warehouses.fallback",
                                    },
                                },
                                exportApplications: {
                                    invoke: {
                                        src: "warehouseExportApplications",
                                        onDone: {
                                            actions: [
                                                (context, event) => {
                                                    context.warehouseExportedApplications = event.data;
                                                },
                                            ],
                                            target: "#warehouses",
                                        },
                                        onError: "#warehouses.fallback",
                                    },
                                },
                            },
                        },
                    },
                },
            },
        },
        authentication: {
            initial: "guest",
            on: {
                LOGOUT: {
                    target: ".guest",
                    actions: ["logOut"],
                },
            },
            states: {
                authenticated: {
                    id: "authenticated",
                    entry: [
                        (context, event) => {
                            context.isAuthenticated = true;
                        },
                        raise("LOAD_ARCOLOGY_CONSTANTS"),
                        "redirectAfterLogin",
                    ],
                },
                guest: {
                    id: "guest",
                    initial: "checkingLoggedIn",
                    states: {
                        checkingLoggedIn: {
                            invoke: {
                                src: "isLoggedIn",
                                onDone: {
                                    target: "#authenticated",
                                },
                                onError: {
                                    target: "login.idle",
                                },
                            },
                        },
                        login: {
                            id: "login",
                            initial: "processing",
                            on: {
                                LOGIN: {
                                    target: ".processing",
                                },
                                API_KEY_CHANGE: ".idle",
                            },
                            states: {
                                idle: {},
                                processing: {
                                    invoke: {
                                        src: "login",
                                        onDone: {
                                            target: "#authenticated",
                                        },
                                        onError: "error",
                                    },
                                },
                                error: {},
                            },
                        },
                    },
                },
            },
        },
    },
});

export {makeMachine};
